import { Card, CardContent, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import NodeTimeRangeGraph from '@/features/service-management/components/energyxplorer/NodeTimeRangeGraph';

const EnergyGroupManagementDrawer = ({ open, onClose, energyGroup }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          height: '100%',
          maxWidth: {
            lg: '60vw',
            sm: '80vw',
            xs: '90vw',
          },
        },
      }}
    >
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          EnergyGroup Details
        </Typography>
        {energyGroup ? (
          <>
            <Grid container spacing={2}>
              <Grid item lg={12}>
                <Card variant="outlined">
                  <CardContent>
                    <HeaderDisplay label={'Energy Group'} />
                    <MultiValueDisplay
                      label={'Name'}
                      value={energyGroup.Name}
                    />
                    <MultiValueDisplay label={'Id'} value={energyGroup.Id} />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12}>
                <Card variant="outlined">
                  <CardContent>
                    <HeaderDisplay label={'Nodes'} />
                    <NodeTimeRangeGraph energyData={energyGroup} />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>{' '}
          </>
        ) : (
          <Typography variant="body1">No account data available.</Typography>
        )}
      </Box>
    </Drawer>
  );
};

export default EnergyGroupManagementDrawer;

const HeaderDisplay = ({ label, description }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        mb: 2,
      }}
    >
      <Typography variant="body1" color="textSecondary" fontWeight="bold">
        {label}
      </Typography>
      {description && <InfoTooltipIcon title={description} />}
    </Box>
  );
};

const MultiValueDisplay = ({ label, value }) => {
  return (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="h6" color="textPrimary">
        {value}
      </Typography>
    </Box>
  );
};
